import React from "react"
import gql from "graphql-tag"
import PropTypes from "prop-types"

import {Mutation} from "../../"
import GetInsGlobal from "../../../client/query/insGlobal"
import {questionGroupFieldsFragment} from "../../../gql/fragments/questionGroup"


const mutation = gql`
  mutation CreatePrivateQuestionGroupWizard($params: QuestionGroupParams!) {
    createQuestionGroup(params: $params){
        ...questionGroupFields
    }
  }
  ${questionGroupFieldsFragment}
`

const CreatePrivateQuestionGroup = ({children, contentId, refetchQueries, ...props}) => {
  return (
    <GetInsGlobal>
      {({tenant: tenantUuid}) => {
        const variables = {params: {name: "Custom group", tenantUuid, contentId}}
        return (
          <Mutation mutation={mutation} {...props}>
            {(mutate, apolloState) => {
              return children(
                (args) => mutate({variables, refetchQueries, ...args}),
                apolloState
              )
            }}
          </Mutation>
        )
      }}
    </GetInsGlobal>
  )
}

CreatePrivateQuestionGroup.propTypes = {
  children: PropTypes.func.isRequired,
  contentId: PropTypes.string
}

CreatePrivateQuestionGroup.defaultProps = {
  children: PropTypes.func.isRequired,
  contentId: null
}

export default CreatePrivateQuestionGroup
